// @ts-nocheck
import React from 'react';
import Text from 'crehana-ui/Text';
import { useTranslation } from '@crehana/i18n';
import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import MobileList from '../MobileList';

const RecentlySeenCourses = ({ items }) => {
  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  return (
    <div>
      <div className="flex items-center mb-24">
        <Text type="h4" as="p" responsive="sm">
          {t('RECENTLY_SEEN')}
        </Text>
      </div>
      <MobileList items={items} origin="Recently seen courses section" />
    </div>
  );
};

export default RecentlySeenCourses;
